import HCLDX from "@system/config/hcldx";
import System from "../../src/helper/system";
import $ from "jquery";
import Constants from "src/helper/Constants";

let c = System.getParams();

class Quote {

    static ADD_QUOTE = System.getCartUrl() + '/api/quote/addItem';
    static ADD_QUOTE_IN_BULK = System.getCartUrl() + '/api/quote/addItems';
    static OPEN_QUOTE_LIST = System.getCartUrl() + '/api/quote/view';
    static SUBMITTED_QUOTE_EMAIL = System.getCartUrl() + '/api/quote/email';
    static CLEAR_ALL_QUOTE = System.getCartUrl() + '/api/quote/clear';
    static CLEAR_SINGLE_QUOTE = System.getCartUrl() + '/api/quote/deleteItem';
    static EDIT_QUOTE = System.getCartUrl() + '/api/quote/update';
    static QUOTE_MIN_PRICE_BY_SPEEDBOAT = System.getCartUrl() + '/api/quote/minprice';
    static QUOTE_SUBMITTED_LIST = System.getCartUrl() + '/api/quote/amer/quoteHeaderDetails';
    static QUOTE_SUBMITTED_DETAIL_LIST_BY_STATUS = System.getCartUrl() + '/api/quote/amer/lineitem';
    static QUOTE_SUBMITTED_DETAIL_LIST_WITH_STATUS = System.getCartUrl() + '/api/quote/amer/searchQuote';
    static SUBMITTED_QUOTE_EXPORT = System.getCartUrl() + '/api/quote/export';
    static QUOTE_DROPDOWN_LIST = System.getCartUrl() + '/api/quote/amer/refQuoteData';
    static QUOTE_PROJECT_DATA = System.getCartUrl() + '/api/quote/amer/quoteProject';
    static ADD_UPDATE_PROJECT_DATA = System.getCartUrl() + '/api/quote/amer/addProjectDetails';
    static SUBMIT_QUOTE = System.getCartUrl() + '/api/quote/amer/submitQuote';
    static EXPORT_QUOTE_LIST = System.getCartUrl() + '/api/quote/amer/exportLineItems';

    static getQuoteRouteURL() {
        return HCLDX.baseURL() + '/resources/myavnet/quote';
    }

    static getQuoteCartRouteURL() {
        return HCLDX.baseURL() + '/shop/quote/cart';
    }

    static getQuoteHeaderDetailRouteURL() {
        c['__c'] = Constants.QuotePages.QuoteHeaderDetail.param_value;
        return this.getURLBasedOnParamKey(c);
    }

    static getQuoteListingRouteURL() {
        c['__c'] = Constants.QuotePages.QuoteListing.param_value;
        return this.getURLBasedOnParamKey(c);
    }

    static getQuoteAddressRouteURL() {
        c['__c'] = Constants.QuotePages.QuoteAddress.param_value;
        return this.getURLBasedOnParamKey(c);
    }

    static getSubmittedQuoteAbsoluteUrl() {
        let c_h = {} 
        c_h['__c'] = Constants.QuotePages.QuoteListing.param_value;
        return this.getURLBasedOnParamKey(c_h);
    }

    static getQuoteDetailRouteURL(extra_c = {}) {
        c['__c'] = Constants.QuotePages.QuoteDetail.param_value;
        return this.getURLBasedOnParamKey({
            ...c,
            ...extra_c
        });
    }

    static getQuoteDetailTabsListRouteURL(extra_c = {}) {
        c['__c_QuoteDetailTabList'] = Constants.QuoteTabList.APR.param_value;
        return this.getURLBasedOnParamKey({
            ...c,
            ...extra_c
        });
    }

    static getQuoteDetailPageRouteURL(c = {}) {
        return Quote.getQuoteDetailRouteURL(c);
    }

    static getURLBasedOnParamKey(c) {
        return HCLDX.baseURL() + '/resources/myavnet/quote?' + $.param(c);
    }

    static getQuoteCheckoutRouteURL() {
        return HCLDX.baseURL() + '/shop/quote/checkout';
    }
}

export default Quote;